import { NavLink } from "react-router-dom";
import "./index.css";

export interface NavBarItem {
  iconName: string;
  label: string;
  route: string;
  onClick?: () => void;
  isHidden?: boolean;
}

interface NavBarProps {
  items: NavBarItem[];
}

const NavBar: React.FC<NavBarProps> = ({ items }) => {
  return (
    <div className="nav-bar">
      <div className="container-nav">
        {items
          .filter((item) => !item.isHidden)
          .map((item, index) => (
            <div
              key={index}
              className="nav-link"
              style={{ cursor: "pointer" }}
            >
              <i className={`bi bi-${item.iconName}`} style={{ cursor: "pointer" }}></i>
              <NavLink
                to={item.route}
                style={{
                  color: "black",
                  margin: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}
                onClick={item.onClick}
              >
                <span>{item.label}</span>
              </NavLink>
            </div>
          ))}
      </div>
    </div>
  );
};

export default NavBar;
